import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FormCheckbox from '../../partials/FormCheckbox';

interface Props {
  required?: boolean;
}

const OwnerOrRepresentativeCheckbox: FC<Props> = ({ required }) => {
  const { t } = useTranslation();
  return (
    <FormCheckbox
      id="isOwnerOrRepresentative"
      name="isOwnerOrRepresentative"
      label={t('contactUs.dmca.ownerCheckbox')}
      required={required}
    />
  );
};

OwnerOrRepresentativeCheckbox.displayName = 'OwnerOrRepresentativeCheckbox';

export default OwnerOrRepresentativeCheckbox;
